import { type ViewCartEvent, viewCartEventSchema } from './eCommerceTrackingEventSchema';
import { getCatalogSourceTrackingData } from './catalogSourceStorage';
import logger from '../logger';

export type ViewCartEventProps = Omit<ViewCartEvent, 'event_name' | 'event'>;

export const buildViewCartEvent = (props: ViewCartEventProps): ViewCartEvent => {
  const viewCartEvent: ViewCartEvent = {
    event: 'ga4_event_ecommerce',
    event_name: 'view_cart',
    ...props,
    ecommerce: { ...props.ecommerce, ...getCatalogSourceTrackingData() }
  };

  const result = viewCartEventSchema.safeParse(viewCartEvent);

  if (!result.success) {
    logger.error(result.error, 'Invalid view cart event');
  }

  return viewCartEvent;
};
